const NS = 'ArticlesLandingPage';
const CLS = 'articlesLandingPage';

export class ArticlesLandingPage {
	constructor(element) {
		this.element = element;
		this.$element = $(this.element);
	}
}
